// P2 client cache — MEMORY ONLY (no persistence: avoids cross-session stale / privacy leakage).
// Correctness-first: default staleTime 0 (always revalidate in background) + SWR render of cache.
// ONLY category-A static/reference data opts into a longer staleTime via REF_STALE. User-scoped,
// transactional and live data are NOT cached here (callers keep their direct fetches / staleTime 0).
import { QueryClient } from '@tanstack/react-query';

export const REF_STALE = 10 * 60 * 1000;   // static/reference: 10 min
export const REF_GC    = 30 * 60 * 1000;

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 0,                 // safe default: always revalidate (SWR shows cache meanwhile)
      cacheTime: REF_GC,
      refetchOnWindowFocus: false,  // WebView: avoid focus refetch storms
      refetchOnReconnect: true,
      retry: 1,
      networkMode: 'always',
    },
  },
});

// Clear ALL cached data on logout / account switch (call when authToken is removed).
export function clearQueryCacheOnLogout() {
  try { queryClient.clear(); } catch (_e) { /* no-op */ }
}
